import { render, staticRenderFns } from "./jtjg.vue?vue&type=template&id=3cab4763&"
import script from "./jtjg.vue?vue&type=script&lang=js&"
export * from "./jtjg.vue?vue&type=script&lang=js&"
import style0 from "./jtjg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports